import React from 'react';
import { useUploadArticlesPublish } from 'contexts/UploadArticlesPublishContext';

/**
 * Barra fija para seguir la publicación masiva aunque se navegue fuera de /cargar-articulos.
 */
export function GlobalPublishJobBanner() {
  const {
    publishing,
    totalToProcess,
    currentProcessing,
    cancelPublish,
    publishJobError,
  } = useUploadArticlesPublish();

  const visible = publishing || totalToProcess > 0;
  if (!visible) {
    return null;
  }

  const pct =
    totalToProcess > 0
      ? Math.round((currentProcessing / totalToProcess) * 100)
      : 0;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 border-b border-blue-200 bg-blue-50 px-4 py-3 shadow-md"
      role="status"
      aria-live="polite"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-blue-950">
            Publicación en curso (podés seguir usando el menú)
          </p>
          <p className="text-xs text-blue-800">
            Artículo {currentProcessing} de {totalToProcess} · {pct}%
          </p>
          <div className="mt-1 h-2 w-full max-w-md rounded-full bg-blue-200">
            <div
              className="h-2 rounded-full bg-blue-600 transition-all duration-300"
              style={{ width: `${pct}%` }}
            />
          </div>
          {publishJobError && (
            <p className="mt-2 text-xs text-red-700">{publishJobError}</p>
          )}
        </div>
        {publishing && (
          <button
            type="button"
            onClick={cancelPublish}
            className="shrink-0 rounded-md border border-red-300 bg-white px-3 py-1.5 text-sm text-red-700 hover:bg-red-50"
          >
            Cancelar publicación
          </button>
        )}
      </div>
    </div>
  );
}
